import * as React from "react";
import Api from "./Api";
import LabelCtl from "./input/LabelCtl";
import SelectCtl from "./input/SelectCtl";
import TextCtl from "./input/TextCtl";
import { Editor } from "@tinymce/tinymce-react";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import "./EmailModalCtl.scss";

interface IEmailModalProps {
    quoteNumber: string;
    toAddresses: string;
    CCaddresses: string;
    fromEmployeeNumber: string;
    subject: string;
    emailMessage: string;
    employeeEmails: ListItem[];
    onCancel: () => void;
    onSubmit: (text: string) => void;
    onChange: (fromEmail: string, toEmail: string, subject: string) => void;
}

interface IEmailModalState {
    emailMessage: string;
    emailModified: boolean;
}

export default class EmailModalCtl extends React.PureComponent<IEmailModalProps, IEmailModalState> {

    constructor(props: IEmailModalProps) {
        super(props);
        this.state = { emailMessage: props.emailMessage, emailModified: false };
    }

    onSubmit = () => {
        this.props.onSubmit(this.state.emailMessage);
    }

    handleEmailEditorChange = (content: string) => {
        this.setState({ emailMessage: content });
    }

    CCaddressChange = (value: string) => {
        this.props.onChange(this.props.fromEmployeeNumber, value, this.props.subject);
    }

    subjectChange = (value: string) => {
        this.props.onChange(this.props.fromEmployeeNumber, this.props.CCaddresses, value);
    }

    fromEmailChange = (fromEmployeeNumber: string) => {
        // If modified, check if the user wants to lose their changes
        if (this.state.emailModified) {
            if (window.confirm('Do you wish to lose your changes to the email by changing the From signature?')) {
                this.loadNewEmail(fromEmployeeNumber);
            }
        } else
            this.loadNewEmail(fromEmployeeNumber);
    }

    loadNewEmail = async (fromEmployeeNumber: string) => {
        try {
            let tmpQuote = await Api.get(`/api/quotes/email/${this.props.quoteNumber}?fromEmployeeNumber=${fromEmployeeNumber}`);
            if (tmpQuote) {
                let emailMessage = atob(tmpQuote.documents[0]?.base64Content ?? "");
                this.setState({ emailMessage: emailMessage, emailModified: false });
            } else {
                window.alert('Unable to get the quote email template. Please submit a service desk ticket.');
                return;
            }
        }
        catch(error: any) {
            window.alert(`Error while getting quote email: ${error.message}. Please submit a service desk ticket.`);
            return;
        }

        this.props.onChange(fromEmployeeNumber, this.props.CCaddresses, this.props.subject);
    }

    render() {
        return <div className="modalScreenBackground">
                   <div className="emailModalDialog">
                       <div className="modalHeader">
                           <LabelCtl className="modalHeaderTitle" label="Send the quote with the following email message?"/>
                           <button className="link" onClick={() => this.props.onCancel()}>
                               <div className="modalCloseButton">
                                   <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M14.5,1.5l-13,13m0-13,13,13" transform="translate(-1 -1)" stroke="#ffffff" stroke-width="3"/>
                                   </svg>
                               </div>
                           </button>
                       </div>
                       <div className="scrollableDiv">
                           <table className="emailTable">
                               <tr>
                                   <td><LabelCtl label="From:" /></td>
                                   <td><SelectCtl items={this.props.employeeEmails} value={this.props.fromEmployeeNumber}
                                                  onChange={this.fromEmailChange} hideItemValue={true} /></td>
                               </tr>
                               <tr>
                                   <td><LabelCtl label="To:" /></td>
                                   <td><LabelCtl className="toAddress" label={this.props.toAddresses} /></td>
                               </tr>
                               <tr>
                                   <td><LabelCtl label="CC:" /></td>
                                   <td><TextCtl value={this.props.CCaddresses} onChange={this.CCaddressChange}
                                                hintText="Separate each email address with a comma"/></td>
                               </tr>
                               <tr>
                                   <td><LabelCtl label="Subject:" /></td>
                                   <td><TextCtl value={this.props.subject} onChange={this.subjectChange}
                                                hintText="Separate each email address with a comma" /></td>
                               </tr>
                           </table>
                           <Editor init={{menubar: false, statusbar: false}} value={this.state.emailMessage} onEditorChange={this.handleEmailEditorChange} apiKey="86kfur1a7ozqh6x40wer1lowo1c5z63d5mcmnt5y85dvqyhk" />
                           <div className="modalBottomButtons">
                               <button className="secondary" onClick={() => this.props.onCancel()}>Cancel</button>
                               <button className="primary" onClick={() => this.onSubmit()}>Send</button>
                           </div>
                       </div>
                   </div>
               </div>;
    }
}
